var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"remoteClient",attrs:{"id":_vm.themeName}},[_c('Header',{attrs:{"theme":_vm.theme}}),_c('router-view',{attrs:{"theme":_vm.theme}}),_c('Status')],1)}
var staticRenderFns = []

export { render, staticRenderFns }